module.exports = __webpack_public_path__ + "img/product-shot_06_loading.8a5c60cc.jpg";